// extracted by mini-css-extract-plugin
export var hidden = "_th-0";